// extracted by mini-css-extract-plugin
export default {"pole":"PoleFormularza_pole__BDlrv","blad":"PoleFormularza_blad__AE4rO","bladIkona":"PoleFormularza_bladIkona__1TL7k","podpowiedz":"PoleFormularza_podpowiedz__PAO74"};